import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { TrackingService2, TrackingService2Symbol, createQuery } from '@/app/tracking/api';
import { QuestionAttemptStoreModule, QuestionAttemptStoreModuleSymbol } from '../../store';
import { QueryQuestionAttemptsTrackingQuery } from '../../tracking/api';

const debug = Debug('query-question-attempts-tracking-state-command');

@injectable()
export class QueryQuestionAttemptsTrackingStateCommandHandler {

  constructor(
    @inject(TrackingService2Symbol)
    private trackingService: TrackingService2,
    @inject(QuestionAttemptStoreModuleSymbol)
    private store: QuestionAttemptStoreModule) {
  }

  public async execute() {

    debug(`querying question attempts' tracking state`);

    this.store.startRemoteQuerying();

    const query = createQuery<QueryQuestionAttemptsTrackingQuery>('query-question-attempts', {})
    const result = await this.trackingService.query(query)

    const states = result.map((x) => ({ ...x }));
    debug(`question attempts' remote tracking state queried: %j`, states);
    this.store.finishRemoteQuerying(states);
  }
}
